import { Injectable } from '@angular/core';
import ISO6391 from 'iso-639-1';

/**
 * Wrapper for iso 639 1 ES module
 */
@Injectable({
  providedIn: 'root',
})
export class Iso6391Helper {

  validate(code: string): boolean {
    return ISO6391.validate(code);
  }

  getNativeName(code: string): string {
    return ISO6391.getNativeName(code);
  }
}
